module.exports = __webpack_public_path__ + "static/media/nomad.bded7e08.png";